<script>
import { connectDeviceService } from '@services/safehaven/ConnectDeviceService'
import DeleteConfirmationDialog from '@components/delete-confirmation-dialog.vue'
import MessageAlert from '@components/message-alert.vue'

export default {
  components: {
    DeleteConfirmationDialog,
    MessageAlert,
  },
  data() {
    return {
      connectedDeviceName: null,
      connectedDeviceList: [],
      validicDeviceList: [],
      openDeleteDialog: false,
      deviceForDelete: null,
      currentUrl: null,
      userData: null,
      validicUserId: null,
      deviceType: null,
      loadingBiometricData: false,
      connected: null,
      disconnectInterval: null,
      connectInterval: null,
      activated: null,
      biometricError: null,
      isShowMessageAlert: false,
      mesasgeText: 'Use the app on your mobile device to disconnect',
    }
  },
  computed: {
    dialogContent() {
      if (!this.deviceForDelete) {
        return ''
      }
      return `Are you sure you want to remove ${this.deviceForDelete} from your Connection Hub?`
    },
    deviceDataStatus() {
      if (this.loadingBiometricData) {
        return 'loading'
      } else if (!this.loadingBiometricData && this.biometricError) {
        return 'error'
      } else return true
    },
  },
  async mounted() {
    this.userData = this.$store.state.auth.currentUser
    this.getValidicUserMarketplaceDevices()
  },
  methods: {
    getValidicUserMarketplaceDevices() {
      connectDeviceService.getValidicUserMarketplaceDevices().then(
        (res) => {
          this.validicDeviceList = res.data
          this.disconnectInterval = this.disconnectInterval
            ? clearInterval(this.disconnectInterval)
            : null
          this.connectInterval = this.connectInterval
            ? clearInterval(this.connectInterval)
            : null
          this.loadingBiometricData = false
        },
        (err) => {
          this.loadingBiometricData = 'error'
          console.warn(err.response.data)
        }
      )
    },
    deleteDevice() {
      try {
        window.open(this.currentUrl, '_blank')
        this.disconnectInterval = setInterval(() => {
          this.getValidicUserMarketplaceDevices()
          this.openDeleteDialog = false
        }, 2000)
      } catch (error) {
        console.warn(error)
      }
    },
    confirmDeleteDevice(selectedDevice, url) {
      if (
        this.connectedDeviceName === 'apple_health' ||
        this.connectedDeviceName === 'google_fit_sdk'
      ) {
        this.isShowMessageAlert = true
      } else {
        this.currentUrl = url
        this.deviceForDelete = selectedDevice
        this.openDeleteDialog = true
      }
    },
    closeDeleteDialog(action) {
      if (action === 'yes') {
        this.deleteDevice()
      } else {
        this.deviceForDelete = null
      }
    },
    hideMessageAlert() {
      this.isShowMessageAlert = false
    },
    openTab(url) {
      window.open(url, '_blank')
      this.loadingBiometricData = true
      this.connectInterval = setInterval(() => {
        connectDeviceService.connectDevice().then((res) => {
          if (res.data.validic_user_status === 'Connected') {
            this.getValidicUserMarketplaceDevices()
          }
        })
      }, 2000)
    },
  },
}
</script>

<template>
  <v-container :class="$style.listContainer">
    <div v-if="!validicDeviceList" :class="$style.loader">
      <v-img
        width="30"
        :src="require('@assets/images/safehaven/refresh.gif')"
      ></v-img>
    </div>
    <v-row v-if="validicDeviceList.length > 0">
      <v-col
        v-for="device in validicDeviceList"
        :key="device.type"
        cols="12"
        xs="12"
        sm="3"
        md="3"
        lg="3"
        xl="3"
      >
        <v-card height="160">
          <v-card-text class="text-center mt-0 pt-0">
            <div :class="[$style.deviceName, device.logo_url ? null : 'pt-5']">
              <img
                width="70"
                :src="device.logo_url"
                :alt="device.display_name"
              />
            </div>
            <div
              v-if="deviceDataStatus === 'loading'"
              :class="[$style.deviceConnectionStatus, 'mb-4']"
            >
              <v-icon class="mr-1" color="#84B25A" size="18">
                mdi-sync-circle
              </v-icon>
              <span>Retrieving data</span>
            </div>
            <div
              v-if="device.connected"
              :class="[$style.deviceConnectionStatus, 'mb-5']"
            >
              <v-icon class="mr-1" color="#84B25A" size="18">
                mdi-check-circle
              </v-icon>
              <span>Connected</span>
            </div>
            <div
              v-if="deviceDataStatus === 'error'"
              :class="[$style.deviceConnectionErrorStatus, 'mb-4']"
            >
              <v-icon class="mr-2" color="#EF4444" size="18">
                mdi-alert-circle
              </v-icon>
              <span>{{ biometricError }}</span>
            </div>
            <div
              v-if="deviceDataStatus !== 'loading' && device.connected"
              :class="[$style.deviceDisconnectStyle, 'ml-1']"
              @click="
                confirmDeleteDevice(device.display_name, device.disconnect_url)
              "
            >
              <span>Disconnect</span>
            </div>
            <div
              v-if="deviceDataStatus !== 'loading' && !device.connected"
              :class="[$style.deviceDisconnectStyle, 'mt-11']"
              @click="openTab(device.connect_url)"
            >
              <span>Connect</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-divider v-if="connectedDeviceList.length > 0" class="mt-5"></v-divider>

    <DeleteConfirmationDialog
      :dialog.sync="openDeleteDialog"
      :content="dialogContent"
      yes-text="Yes, remove"
      no-text="Don't remove"
      @closeDeleteDialog="closeDeleteDialog"
    ></DeleteConfirmationDialog>
    <MessageAlert
      :show-alert="isShowMessageAlert"
      :alert-message="mesasgeText"
      @close-alert="hideMessageAlert"
    ></MessageAlert>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.deviceName {
  font-size: 14px;
  font-weight: bold;
  color: #000;
}

.deviceConnectionStatus {
  font-size: 14px;
  font-weight: 400;
  color: #84b25a;
}

.deviceConnectionErrorStatus {
  font-size: 14px;
  font-weight: 400;
  color: #ef4444;
}

.deviceDisconnectStyle {
  font-size: 14px;
  font-weight: 700;
  color: #057cfc;
}

.loader {
  height: 50px;
}
</style>
